import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LESSON_FEATURE_KEY } from './keys';
import { lessonReducer } from './reducers/lesson.reducer';
import { LessonEffects } from './effects/lesson.effects';
import { NextLessonBridge } from './bridges/next_lesson.bridge';

export const lessonStoreProviders = [provideState(LESSON_FEATURE_KEY, lessonReducer), provideEffects(LessonEffects, NextLessonBridge)];

export { LessonFacade } from './facades/lesson.facade';
export { lessonCleanup } from './guards/cleanup.guard';
export * from './models';
export { lessonActions } from './actions/lesson.actions';
